import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsAgentStudioHandoffRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-agent-studio-handoff',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/handoff',
	exact: true,
};
